import client from '@/services/client.js'

const endpoint = 'statistic'

const getStatistic = () => {
  return client.get(endpoint)
}

export { getStatistic }
